import { render } from "./favouritePage.vue?vue&type=template&id=1151a45a"
import script from "./favouritePage.vue?vue&type=script&lang=js"
export * from "./favouritePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__